export default __webpack_public_path__ + "static/milan-mobile-6bf6cc25e74a265aef0a746f5479cb94.png";